import { Component, Inject, OnInit } from '@angular/core';
import { PartnersExtras, PartnersModel } from './partners.model';
import { PartnersService } from './partners.service';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { PartnersListComponent } from './partners-list.component';
import { AccountMovementsViewModel } from '../../../accounting/models/accounting-movement.model';
import { SharedService } from '../../../../shared/services/shared.service';
import { PartnerDialogImportAccount } from './partners-dialog-importAccount.component';


@Component({
    selector: 'app-partners-form',
    templateUrl: './partners-form.component.html',
    styleUrls: ['./partners-form.component.css'],
    standalone: false
})
export class PartnersFormComponent implements OnInit {

  uid: number = this.data.uid;
  ready: boolean = false;
  vatNumberFormControl: UntypedFormControl;
  nameOrBusinessNameFormControl: UntypedFormControl;
  partnersModel: PartnersModel;
  submitted: boolean = false;

  //AccountMovementes Import data
  flagImport: boolean = this.data.flagImport;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //------------------------------

  public partnersExtras: PartnersExtras;

  remunerated_options = [
    { value: true, text: 'Cargo remunerado' },
    { value: false, text: 'Cargo no remunerado' },
  ]

  constructor(
    public partnersService: PartnersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PartnersListComponent>,
    public snackBar: MatSnackBar,
    private sharedService: SharedService
  ) {
    this.partnersModel = new PartnersModel();
    this.nameOrBusinessNameFormControl = new UntypedFormControl();
    this.vatNumberFormControl = new UntypedFormControl();
  }

  ngOnInit() {
    if (this.uid != undefined && this.uid !== 0) {
      this.partnersModel.uid = this.uid;
      this.ready = false;

      this.partnersService.loadData(this.uid).then(partners => {
        this.partnersModel = partners;
        this.vatNumberFormControl.setValue(partners.vatNumber || '');
        this.ready = true;
      });
    } else {
      if (this.data.flagImport !== undefined) {
        if (this.data.flagImport) {
          this.movement = this.data.movement;
          this.type = this.data.type;
          this.movement.type = this.type;
          this.partnersModel.participationAmount = this.movement.amount;
          this.partnersModel.manualMovement = this.movement;
          this.partnersModel.nameOrBusinessName = this.movement.reference;

          this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
            this.partnersModel.accountingModels551 = response;
            this.partnersModel.manualMovement.accountNumber = response;
          })
        }
      }

      this.ready = true;
    }

    this.ready = false;
    this.partnersService.partnersExtras().then((response: PartnersExtras) => {
      this.partnersExtras = response;
      this.ready = true;
    });
  }

  public closeDialog() {
    this.dialogRef.close(this.saved);
  }

  // SAVE
  onSubmit() {
    if (this.vatNumberFormControl.invalid) {
      this.vatNumberFormControl.markAsTouched();
    }

    if (!this.partnersModel.remunerated) {
      this.partnersModel.remunerated = false;
    }

    if (!this.partnersModel.partnersPositionId) {
      this.partnersModel.partnersPositionId = 1;
    }

    if (!this.partnersModel.partnersTypesId) {
      this.partnersModel.partnersTypesId = 1;
    }

    if (this.isDataValid()) {
      this.partnersModel.vatNumber = this.vatNumberFormControl.value;
      this.submitted = true;
      this.save(this.partnersModel);
    } else {
      this.displayInfo('Compruebe los campos marcados en rojo');
      return;
    }
  }

  private isDataValid(): boolean {
    if (!this.vatNumberFormControl.invalid) {
      return true;
    }
    return false;
  }

  save(partnersModel) {
    const noError = true;
    const mensajeError = '';

    if (noError) {
      if (partnersModel.uid == null) {
        this.saved = true;
        this.partnersService.addData(partnersModel)
          .then(partnersModel => {
            this.partnersModel = partnersModel;
            this.closeDialog();
            this.dummy.redirectTo('/partnersequity/partners');
          },
            error => this.displayInfo(error.error['message'])
          )
      } else {
        this.partnersService.editData(partnersModel.uid, partnersModel)
          .then(partnersModel => {
            this.partnersModel = partnersModel;
            this.dummy.redirectTo('/partnersequity/partners');
          },
            error => this.displayInfo(error.error['message'])
          )
      }
      this.dialogRef.close(true);
    } else {
      this.displayInfo(mensajeError);
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }
}
